import { render, staticRenderFns } from "./AuxNode.vue?vue&type=template&id=bf885d4c&scoped=true&"
import script from "./AuxNode.vue?vue&type=script&lang=js&"
export * from "./AuxNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf885d4c",
  null
  
)

export default component.exports